export default "__VITE_ASSET__1e3f2ace__"